import {SearchDateRange} from '../interfaces/SearchDateRange';

export const DEFAULT_SEARCH_BOUNCE = 2;


export const PERIODS_LIST = [
  {id: SearchDateRange.Last90Days, name: 'Last 90 days'},
  {id: SearchDateRange.Today, name: 'Today'},
  {id: SearchDateRange.ThisWeek, name: 'This week'},
  {id: SearchDateRange.LastWeek, name: 'Last week'},
  {id: SearchDateRange.ThisMonth, name: 'This month'},
  {id: SearchDateRange.LastMonth, name: 'Last month'},
  {id: SearchDateRange.ThisQuarter, name: 'This quarter'},
  {id: SearchDateRange.LastQuarter, name: 'Last quarter'},
  {id: SearchDateRange.ThisYear, name: 'This year'},
  {id: SearchDateRange.LastYear, name: 'Last year'},
];

export const TRANSACTION_TABLE_PERIODS_LIST = () => {
  const copy = [...PERIODS_LIST];
  copy.splice(0, 0, {id: SearchDateRange.Last30Days, name: 'Last 30 days'});
  return copy;
}
